module.exports = __webpack_public_path__ + "img/panda_player_icon.cd260097.svg";